"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
/**
 * Operator.
 */
var Operator = /** @class */ (function () {
    function Operator(name, fn) {
        this.name = name;
        this.fn = fn;
    }
    /**
     * Use the provided callback function to evaluate to values.
     *
     * @param a Left side value.
     * @param b Right side value.
     */
    Operator.prototype.evaluate = function (a, b) {
        return this.fn(a, b);
    };
    return Operator;
}());
exports.Operator = Operator;
//# sourceMappingURL=operator.js.map